
import { wagmiAdapter, projectId } from '../Wagmi/config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createAppKit } from '@reown/appkit/react';
import { mainnet } from '@reown/appkit/networks';
import React from 'react';
import { WagmiProvider } from 'wagmi';

// Set up queryClient
const queryClient = new QueryClient();

if (!projectId) {
  throw new Error('Project ID is not defined');
}

// Set up metadata
const metadata = {
  name: 'Shadow node',
  description: 'Decentralized Privacy for a Connected World',
  url: '#',
  icons: ['https://avatars.githubusercontent.com/u/179229932']
};

// Custom theme variables
const customTheme = {
  '--w3m-font-family': 'CircularStd, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  '--w3m-accent': '#fe8b00',
  '--w3m-color-mix': '#ffffff',
  '--w3m-color-mix-strength': 40,
  '--w3m-color-bg-1': '#ffffff',
  '--w3m-color-bg-2': '#f8f9fa',
  '--w3m-color-bg-3': '#f1f3f4',
  '--w3m-color-fg-1': '#141414',
  '--w3m-color-fg-2': '#949494',
  '--w3m-color-fg-3': '#c4c7c7',
  '--w3m-z-index': 9999,
};

const darkTheme = {
  ...customTheme,
  '--w3m-color-bg-1': '#1a1a1a',
  '--w3m-color-bg-2': '#2d2d2d',
  '--w3m-color-bg-3': '#3a3a3a',
  '--w3m-color-fg-1': '#ffffff',
  '--w3m-color-fg-2': '#b4b4b4',
  '--w3m-color-fg-3': '#8a8a8a',
};

// Create the modal
const modal = createAppKit({
  adapters: [wagmiAdapter],
  projectId,
  networks: [mainnet],
  defaultNetwork: mainnet,
  metadata: metadata,
  features: {
    analytics: true,
    email: false,
    socials: false,
    emailShowWallets: true,
  }, 
  allWallets: 'SHOW',

  themeMode: 'dark',

  themeVariables: {
    light: customTheme,
    dark: darkTheme,
    '--w3m-border-radius-master': '2.2px',
  }
});

function WagmiWrapper({ children }) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default WagmiWrapper;